import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _extends from 'babel-runtime/helpers/extends';

/* eslint-disable max-lines */
import _ from 'lodash';
import Search from '@/components/SearchV3/index.vue';
import TableList from '@/components/TableList/index.vue';
import searchMixin from '@/mixin/search';
import Pagination from '@/components/Pagination/index.vue';
import { getCloudUsages } from '@/api/dashboard/playturbo.js';
import { format, subDays } from 'date-fns';
import { downloadWithNewWindow } from '@/common/download';
import { v2Host } from '@/config/host';
import qs from 'qs';
import { fmtSeconds } from '@com/utils/data-format';
import { cookRequestParams } from '@/common/request';
import tableMixin from './table-mixin';

var defaultQuery = {
  page: 1,
  page_size: 50,
  time: [format(subDays(new Date(), 1), 'YYYY-MM-DD'), format(subDays(new Date(), 1), 'YYYY-MM-DD')],
  export: 0
};

export default {
  mixins: [searchMixin, tableMixin],

  components: {
    Search: Search,
    TableList: TableList,
    Pagination: Pagination
  },
  data: function data() {
    return {
      query: _extends({}, defaultQuery),

      list: [],
      listLoading: false,

      tableConfig: {
        'row-key': '_id'
      },

      pagination: {
        total: 0
      }
    };
  },


  computed: {
    formItemList: function formItemList() {
      var list = {
        time: {
          type: 'date-picker',
          subtype: 'daterange',
          prop: 'time',
          class: 'date-picker',
          params: {
            clearable: false,
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd',
            pickerOptions: {
              /* eslint-disable no-mixed-operators */
              // 限定只能选择前180天的日期
              disabledDate: function disabledDate(time) {
                var curDate = new Date().getTime();
                var threeMonths = curDate - 180 * 24 * 3600 * 1000;
                return time.getTime() > Date.now() || time.getTime() < threeMonths;
              },

              shortcuts: [{
                text: '最近三天',
                onClick: function onClick(picker) {
                  var end = new Date();
                  var start = new Date();
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 3);
                  picker.$emit('pick', [start, end]);
                }
              }, {
                text: this.$t('form.pastWeek'),
                onClick: function onClick(picker) {
                  var end = new Date();
                  var start = new Date();
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                  picker.$emit('pick', [start, end]);
                }
              }, {
                text: '最近半个月',
                onClick: function onClick(picker) {
                  var end = new Date();
                  var start = new Date();
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 15);
                  picker.$emit('pick', [start, end]);
                }
              }]
            }
          }
        }
      };
      return list;
    },
    tableColumnConfig: function tableColumnConfig() {
      var tableList = [{
        label: '日期',
        prop: 'date'
      }, {
        label: 'App Id',
        prop: 'app_id',
        params: {
          innerHTML: function innerHTML(_ref) {
            var row = _ref.row;

            return row.app_id || '-';
          }
        }
      }, {
        label: 'App Name',
        prop: 'app_name',
        params: {
          innerHTML: function innerHTML(_ref2) {
            var row = _ref2.row;

            return row.app_name || '-';
          }
        }
      }, {
        label: '导出项目数',
        prop: 'project_count',
        dataFormat: {
          type: 'number', // string，可选 number/text/percentage/currency/permillage
          thousandsSeparator: true // boolean，是否要千位分隔符
        }
      }, {
        label: '导出任务数',
        prop: 'task_count',
        dataFormat: {
          type: 'number', // string，可选 number/text/percentage/currency/permillage
          thousandsSeparator: true // boolean，是否要千位分隔符
        }
      }, {
        label: '导出视频数',
        prop: 'video_count',
        dataFormat: {
          type: 'number', // string，可选 number/text/percentage/currency/permillage
          thousandsSeparator: true // boolean，是否要千位分隔符
        }
      }, {
        label: '导出视频时长',
        prop: 'video_duration',
        params: {
          innerHTML: function innerHTML(_ref3) {
            var row = _ref3.row;

            return row.video_duration ? fmtSeconds(row.video_duration / 1000) : '-';
          }
        }
      }, {
        label: '导出图片数',
        prop: 'image_count',
        dataFormat: {
          type: 'number', // string，可选 number/text/percentage/currency/permillage
          thousandsSeparator: true // boolean，是否要千位分隔符
        }
      }];

      return tableList;
    }
  },

  watch: {
    $route: function $route(to, from) {
      if (_.isEmpty(to.query)) {
        this.query = _extends({}, defaultQuery);
      }
      this.dispatch();
    }
  },

  mounted: function mounted() {
    this.dispatch();
  },


  methods: {
    exportSheet: function exportSheet() {
      var params = _extends({}, this.query, {
        export: 1
      });
      downloadWithNewWindow(v2Host + '/dashboard/ceditor/usage-report?' + qs.stringify(_extends({}, cookRequestParams(params))));
    },
    handleSortChange: function handleSortChange(_ref4) {
      var column = _ref4.column,
          prop = _ref4.prop,
          order = _ref4.order;

      if (order) {
        this.query.order = (order === 'descending' ? '-' : '') + prop;
      } else {
        this.query.order = '';
      }
      this.$router.push({
        query: this.query
      });
    },
    dispatch: function dispatch() {
      this.getMaterialReport();
    },
    getMaterialReport: function getMaterialReport(params) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var innerParams, res, sum, list;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.listLoading = true;
                _context.prev = 1;
                innerParams = _.omit(_.cloneDeep(params || _this.query));
                _context.next = 5;
                return getCloudUsages(_extends({}, innerParams));

              case 5:
                res = _context.sent;
                sum = _.get(res, 'data.data.sum', []);
                list = sum.concat(_.get(res, 'data.data.list') || []);

                _this.list = list;
                _this.pagination.total = _.get(res, 'data.data.total') || 0;
                _this.listLoading = false;
                _context.next = 16;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context['catch'](1);

                _this.listLoading = false;

              case 16:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[1, 13]]);
      }))();
    },
    handleColumnFilterChange: function handleColumnFilterChange() {
      this.query.page = 1;
      this.handleSearch(this.query);
    },
    resetSearch: function resetSearch() {
      this.handleResetSearch();
    }
  }
};